<div class="wrapper">

  <!-- Preloader -->
  <!-- <div class="preloader flex-column justify-content-center align-items-center">
    <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
  </div> -->

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <div class="navbar-nav forHeigh">
        <li class="nav-item">
            <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
        <div class="row" style="justify-content: center;align-items: center;">
         <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2 forImg" style="opacity: .8;">
         <h5  class="forImgTxt">MyRoots</h5>
        </div>  <!-- <li class="nav-item d-none d-sm-inline-block">
      <a href="index3.html" class="nav-link">Home</a>
    </li>style=""
    <li class="nav-item d-none d-sm-inline-block">
      <a href="#" class="nav-link">Contact</a>
    </li> -->
  </div>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Navbar Search -->
      <!-- <li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" href="#" role="button">
          <i class="fas fa-search"></i>
        </a>
        <div class="navbar-search-block">
          <form class="form-inline">
            <div class="input-group input-group-sm">
              <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
              <div class="input-group-append">
                <button class="btn btn-navbar" type="submit">
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li> -->

      
    </ul>
  </nav>
  <!-- /.navbar -->

  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-primary elevation-4" style="position: fixed;">
    <!-- Brand Logo -->
    <a style="display: inline-flex;padding-top: 10px;
    padding-left: 80px;color:#015792;">
      <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2" style="opacity: .8;width:40%">
      <span class="brand-text " style="margin-left: 10px;margin-top:15px;"></span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3  d-flex">
        <!-- <div class="image">
          <img src="assets/user-icon.png" class="img-circle elevation-2" alt="User Image">
        </div> -->
        <div class="">
          <a  class="d-block newcolor"> DISTRICT ADMIN</a>
        </div>
      </div>

      <!-- SidebarSearch Form -->
      <!-- <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div> -->

      <!-- Sidebar Menu -->
      <nav class="mt-2">
          <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" style="height:100%;">
            <li class="nav-item">
              <a [routerLink]="['Dashboard']" class="nav-link" data-widget="pushmenu">
                <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <g fill="black">
                    <path
                      d="M11.47 3.84a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.06l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 0 0 1.061 1.06z" />
                    <path
                      d="m12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086z" />
                  </g>
                </svg></i>
                <p style="margin-left:8px;color:black;">
                  Dashboard
                </p>
              </a>
            </li>
              <!-- <li class="nav-item">
                  <a  [routerLink]="['Dashboard']" class="nav-link">
                    <i class=""></i>
                      
                     </p>
                  </a>
                </li> -->
               
              
                <li class="nav-item">
                  <a  [routerLink]="['course-district']" class="nav-link" data-widget="pushmenu">
                    <i><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                      <path fill="black"
                        d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.5 5.5 0 0 1-.72-2M19 2h-5v5l-2-1.5L10 7V2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.09A6 6 0 0 1 21 13.34V4a2 2 0 0 0-2-2m1 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z" />
                    </svg></i>
                    <p style="margin-left:8px;color:black;" >Course District Occurence</p>
                  </a>
                </li>

                    <li class="nav-item">
                      <a [routerLink]="['course-attendance']" class="nav-link" data-widget="pushmenu">
                        <i><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16">
                          <path fill="black"
                            d="M7 14s-1 0-1-1s1-4 5-4s5 3 5 4s-1 1-1 1zm4-6a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5" />
                        </svg></i>
                        <p style="margin-left:8px;color:black;" >Course Attendance</p>
                      </a>
                    </li>

                <li class="nav-item">
                  <a [routerLink]="['dastudent']" class="nav-link" data-widget="pushmenu">
                    <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                      <path fill="black" fill-rule="evenodd"
                        d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                        clip-rule="evenodd" />
                    </svg></i>
                    <p style="margin-left:8px;color:black;" >
                      Student List
                    </p>
                  </a>
                </li>

                    <li class="nav-item">
                      <a [routerLink]="['damentor']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="black" fill-rule="evenodd"
                            d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                            clip-rule="evenodd" />
                        </svg></i>
                        <p style="margin-left:8px;color:black;" >
                          Mentor List
                        </p>
                      </a>
                    </li>

                    <li class="nav-item">
                      <a [routerLink]="['mentor-session']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="bi bi-person-raised-hand" viewBox="0 0 24 24">
                          <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207"/>
                          <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                        </svg></i>
                        <p style="margin-left:8px;color:black;" >
                          Mentor session volunteer
                        </p>
                      </a></li>


                      <li class="nav-item">
                        <a [routerLink]="['da-mentor-volunteer']" class="nav-link" data-widget="pushmenu">
                          <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="bi bi-person-raised-hand" viewBox="0 0 24 24">
                            <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207"/>
                            <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                          </svg></i>
                          <p style="margin-left:8px;color:black;" >
                            Mentor volunteer
                          </p>
                        </a>
                      </li>
                    <li class="nav-item">
                      <a [routerLink]="['dastudent-feedback']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48">
                          <path fill="black"
                            d="M30.27 25c-.24 0-.49-.04-.73-.12A2.211 2.211 0 0 1 28 22.75v-2.81c-2.26-.36-4-2.33-4-4.69v-6.5C24 6.13 26.13 4 28.75 4h11.5C42.87 4 45 6.13 45 8.75v6.5c0 2.62-2.13 4.75-4.75 4.75h-5.12l-3.08 4.1c-.44.58-1.09.9-1.78.9M16 27.5c-4.14 0-7.5-3.36-7.5-7.5c0-4.14 3.36-7.5 7.5-7.5c4.14 0 7.5 3.36 7.5 7.5c0 4.14-3.36 7.5-7.5 7.5M3 34.79c0 .09.15 9.21 13 9.21s13-9.12 13-9.21v-1.04c0-2.07-1.68-3.75-3.75-3.75H6.75C4.68 30 3 31.68 3 33.75z" />
                        </svg></i>
                        <p style="margin-left:8px;color:black;">
                          Student Feedback List
                        </p>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a [routerLink]="['damentor-feedback']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48">
                          <path fill="black"
                            d="M30.27 25c-.24 0-.49-.04-.73-.12A2.211 2.211 0 0 1 28 22.75v-2.81c-2.26-.36-4-2.33-4-4.69v-6.5C24 6.13 26.13 4 28.75 4h11.5C42.87 4 45 6.13 45 8.75v6.5c0 2.62-2.13 4.75-4.75 4.75h-5.12l-3.08 4.1c-.44.58-1.09.9-1.78.9M16 27.5c-4.14 0-7.5-3.36-7.5-7.5c0-4.14 3.36-7.5 7.5-7.5c4.14 0 7.5 3.36 7.5 7.5c0 4.14-3.36 7.5-7.5 7.5M3 34.79c0 .09.15 9.21 13 9.21s13-9.12 13-9.21v-1.04c0-2.07-1.68-3.75-3.75-3.75H6.75C4.68 30 3 31.68 3 33.75z" />
                        </svg></i>
                        <p style="margin-left:8px;color:black;">
                          Mentor Feedback List
                        </p>
                      </a>
                    </li>
           
                 <!-- <li class="nav-item">
                  <a  [routerLink]="['menu-change-password']" class="nav-link">
                    <i class=""></i>
                    <p>
                      Change Password
                     </p>
                  </a>
                </li> -->
           
                
               
               
                  <li class="nav-item">
                    <a [routerLink]="['login']" class="nav-link">
                      <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                        <path fill="black"
                          d="M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33a1 1 0 0 0 0-.76a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" />
                      </svg></i>
                      <p style="margin-left:8px;color:black;" (click)="signout()">
                        Sign Out
                      </p>
                    </a>
                  </li>

          </ul>
        
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <!--  -->
    <!-- /.content-header -->

    <div style="min-height: 600px;">
      <router-outlet></router-outlet>
    </div>
      <div class="footer" >
        <div class="text-center p-3">
          <p>Copyright © MyRoots. Developed by <a target="_blank">RedMind Technologies</a> {{footerdate}}</p>
        </div>
       
      </div>
  </div>
  <!-- /.content-wrapper -->
  <!-- <footer class="main-footer">
    <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.2.0
    </div>
  </footer> -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->
</div>